// @ts-nocheck

import React from 'react';
import type { ComponentType } from 'react';
import styled, { css } from 'styled-components';

import { Target } from '../../client';
import { __ } from '../../i18n/l10n';
import theme from '../../styled-components/dark';
import Counter from '../Counter';

const Button = styled.div`
  position: relative;
  flex: 1;
  width: 100%;
  border: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  transition: background-position 200ms ease-in-out;
  background-size: 200% 100%;
  background-position: 99% 0%;
  max-height: 5.5em;
  min-height: 3em;
  border-bottom: 1px solid ${theme.BurgerMenu.Button.borderColor};

  &:after {
    transition: all 100ms ease-in-out;
    position: absolute;
    content: '';
    left: 0;
    top: 0;
    width: 0.2em;
    height: 100%;
    background-color: ${theme.BurgerMenu.Button.after.backgroundColor};
  }

  ${Target.__MOBILE__
    ? css`
        &:active {
          background-position: 0% 0%;
          &:after {
            background-color: white;
          }
        }
      `
    : css`
        &:hover {
          background-position: 0% 0%;
          &:after {
            background-color: white;
          }
        }
      `}

  &:before {
    position: absolute;
    content: '';
    left: 0;
    top: 0;
    width: 100%;
    height: 1px;
    background-color: ${theme.BurgerMenu.Button.before.backgroundColor};
  }

  &:first-of-type {
    &:before {
      display: none;
    }
  }

  &:nth-child(odd) {
    background-image: ${theme.BurgerMenu.Button.odd.backgroundGradient};
  }

  &:nth-child(even) {
    background-image: ${theme.BurgerMenu.Button.even.backgroundGradient};
  }
`;

const LeftColumn = styled.div`
  position: relative;
  flex: 6;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const iconDim = 3;
const gapBetweenIconAndLabel = 1;
const rowSideMargin = 1.5;

const ButtonLabel = styled.span`
  width: calc(100% - ${iconDim}em - ${rowSideMargin}em);
  margin-left: ${gapBetweenIconAndLabel / 2}em;
  color: ${theme.BurgerMenu.Label.color};
  font-size: 1.25em;
  font-weight: 600;
`;

const RightColumn = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 2em;
`;

const Additional = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LiveBadge = styled(Additional)`
  border-radius: 0.2em;
  text-transform: uppercase;
  background-color: ${theme.BurgerMenu.LiveBadge.backgroundColor};
  color: ${theme.BurgerMenu.LiveBadge.color};
  padding: 0.3em;
`;

export type Props = {
  label: string;
  onClick: (...params: unknown) => unknown;
  counter: number | null;
  icon: ComponentType<unknown>;
  isLive?: boolean;
};

const NavigationBurgerMenuItem = ({ label, onClick, icon, isLive = false, counter = null }: Props) => {
  const Icon = icon || undefined;
  return (
    <Button onClick={onClick}>
      <LeftColumn>
        {Icon ? <Icon /> : null}
        <ButtonLabel>{label}</ButtonLabel>
      </LeftColumn>
      {isLive ? (
        <RightColumn>
          <LiveBadge>{__('Live')}</LiveBadge>
        </RightColumn>
      ) : null}
      {counter !== null ? (
        <RightColumn>
          <Counter counter={counter} />
        </RightColumn>
      ) : null}
    </Button>
  );
};

export default NavigationBurgerMenuItem;
